import api from '@/api/api.js'

export default {
    getTypeChamps() {
        const promise = api().get('/champs/type_champs')
        return promise.then((response) => response.data)
    },

    

    getListeOccurences() {
        const promise = api().get('/champs/occurences')
        return promise.then((response) => response.data)
    },

    saveChamp(data) {
        const promise = api().post('/champs/store', data)
        return promise.then((response) => response.data)
    },

    saveDynamicalField(data) {
        const promise = api().post('/champs/dynamic/store', data)
        return promise.then((response) => response.data)
    },

    getListeChamps(data_type) {
        const promise = api().get('/champs/'+data_type+'/liste')
        return promise.then((response) => response.data)
    },

    getDynamicField(data_type) {
        const promise = api().get('/champs/'+data_type+'/liste_dynamic_field')
        return promise.then((response) => response.data)
    },

    getChampExamClinique(data) {
        const promise = api().get('/champs/'+data.data_type+'/type_consultation/'+data.type_consultation_id+'/consultation/'+data.consultation_id)
        return promise.then((response) => response.data)
    },

    getChampAtcdEnfpersPhysio(data) {
        const promise = api().get('/champs/atcd_enf_perso/'+data.data_type+'/type_consultation/'+data.type_consultation_id+'/consultation/'+data.consultation_id)
        return promise.then((response) => response.data)
    },

    getChampsTauxAssurance(assurance_id) {
        const promise = api().get('/assurances/souscripteurs/'+assurance_id+'/taux/champs')
        return promise.then((response) => response.data)
    },

    saveTauxChamp(data) {
        const promise = api().post('/assurances/taux/champs/store', data)
        return promise.then((response) => response.data)
    },

    saveTauxCouverture(data) {
        const promise = api().post('/assurances/taux_couverture/store', data)
        return promise.then((response) => response.data)
    },

    deleteTauxCouverture(data) {
        const promise = api().post('/assurances/taux_couverture/delete', data)
        return promise.then((response) => response.data)
    },

    getListeTypeMixData(data_type) {
        const promise = api().get('/champs/type_champs/'+data_type+'/liste_data')
        return promise.then((response) => response.data)
    },

    getListeModeAdministration() {
        const promise = api().get('/parametres/mode-administration')
        return promise.then((response) => response.data)
    },

    saveModeAdministration(data) {
        const promise = api().post('/parametres/mode-administration/save', data)
        return promise.then((response) => response.data)
    },

    deleteModeAdministration(data) {
        const promise = api().post('/parametres/mode-administration/delete', data)
        return promise.then((response) => response.data)
    },
}